module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian-style3/accordian-style3.component.scss
// module id = ./src/app/features/accordian/accordian-style3/accordian-style3.component.scss
// module chunks = main